import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ProfileNavBar from '../ProfileNavBar/ProfileNavBar';

const APIProgram = () => {
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]);
    const [pdfs, setPdfs] = useState([]);

    useEffect(() => {
        // Simulating fetching PDF files from the Dummy folder within the same directory
        const pdfFiles = [
            'Add Payment to Invoice API.pdf',
            'Add Receipt API.pdf',
            'Add Refund API.pdf',
            'API to download Invoice API.pdf',
            'API to download Receipt API.pdf',
            'Calendar Module API.pdf',
            'Cancel Invoice API.pdf',
            'Delete CreditNote API.pdf',
            'Delete Draft Invoice API.pdf',
        ];
        setPdfs(pdfFiles);
    }, []);

    const handleAddNewListing = () => {
        navigate('/vendors/add-listing');
    };
    return (
        <div className="flex flex-col p-4">
        <p className="text-lg md:text-xl 2xl:text-2xl mt-4 text-center">
            Thank you for joining our API Program! Please find our documentation below.
        </p>
    
        {/* Responsive Table for PDFs */}
        <div className="overflow-x-auto mt-6">
            <table className="min-w-full bg-white shadow-md rounded-lg border border-gray-300">
                <thead>
                    <tr className="bg-gray-100 text-gray-700">
                        <th className="px-4 py-2 text-left text-sm md:text-base font-semibold">Document Name</th>
                        <th className="px-4 py-2 text-left text-sm md:text-base font-semibold">Download</th>
                    </tr>
                </thead>
                <tbody>
                    {pdfs.map((pdf, index) => (
                        <tr key={index} className="border-b border-gray-200 hover:bg-gray-50">
                            <td className="px-4 py-2 text-gray-800 text-sm md:text-base">{pdf.replace('.pdf', '')}</td>
                            <td className="px-4 py-2">
                                <a
                                    href={`/Dummy/${pdf}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 hover:underline text-sm md:text-base"
                                >
                                    View PDF
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    
        <div className="mt-8 text-xl md:text-2xl 2xl:text-3xl font-bold border-b-2 border-exploreCategoriesBackground pb-2 text-center">
            FHIR APIs
        </div>
    
        <button
            className="mt-8 text-white text-lg xl:text-xl font-semibold px-4 xl:px-5 py-2 xl:py-3 bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit mx-auto rounded-full"
            onClick={() => window.open('https://www.charmhealth.com/resources/fhirapi/#introduction', '_blank', 'noopener,noreferrer')}
        >
            Go to FHIR API Documentation
        </button>
    </div>
    
    );
};

export default APIProgram;
